<template>
  
  <div class="user">
    <app-header/>
    
    <div class="container">

      

      <div class="box-btn">
        <div class="float-right">
          <button type="button" v-b-modal.modalFilters class="btn btn-primary">
            Filtrar
          </button>
        </div>

        <div class="d-inline mr-4">
          <button type="button" v-b-modal.createUser v-on:click="openCreate" class="btn btn-primary">
            Usuario
          </button>
        </div>
        

        <div class="d-inline">
          <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
            CSV
          </button>
        </div> 
      </div>
      
      <div class="table table-padded">
        

        <b-card mb-2>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
          
          :items="users"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          @filtered="onFiltered" class="table table-padded"
          >
          <template slot="id" slot-scope="row">
           {{row.item.id}}
         </template>

         <template slot="username" slot-scope="row">
           {{row.item.username}}
         </template>


         <template slot="name" slot-scope="row">
           {{row.item.name}}
         </template>

         <template slot="Company.name" slot-scope="row">
           {{row.item.Company.name}}
         </template>

         <template slot="Rol.name" slot-scope="row">
           {{row.item.Rol.name}}
         </template>


         
         <template slot="action" slot-scope="row" >
          
          <button  class="actionBtnTable nobtn" v-b-modal.createUser v-on:click='edit(row.item)'>
            <i class="material-icons" style="color: #dab51b;" >edit</i>
          </button>
                <!-- <button class="actionBtnTable nobtn" v-b-modal.deleteUser v-on:click='currentUser(row.item)' >
                  <i class="material-icons"  style="color: #dab51b;">delete_outline</i>
                </button> -->
                
              </template> 
              

            </b-table>

            <b-row>
              <b-col md="12" class="my-1 float-right">
                <b-pagination :total-rows="users.length" :per-page="perPage" v-model="currentPage" class="my-0" />
              </b-col>
            </b-row>


          </b-card >
          

        </div>

      </div>
      
      <app-footer/>

      <b-modal id="deleteUser" ref="deleteUser" title="Eliminar usuario"  size="sm" centered>
        <form >

          <div class="form-group">
           <p>Esta seguro que desea eliminar este usuario?</p>
         </div>
       </form>

     </b-modal>

     <b-modal id="createUser" ref="createUser" title="Usuario" @ok="submitForm()">

      <form>


        <div class="form-group">
          <label>Nombre</label>
          <input type="text" class="form-control" v-model="formCreate.name">
        </div>

        <template v-if="!formCreate.id">

          <div class="form-group">
            <label>Usuario</label>
            <input type="text" class="form-control" v-model="formCreate.username">
          </div>
        </template>

        <div class="form-group">
          <label>Contraseña</label>
          <input type="text" class="form-control" v-model="formCreate.password">
        </div>

        <div class="form-group">
          <label>Celular</label>
          <input type="text" class="form-control" v-model="formCreate.cellphone">
        </div>

        <template v-if="!formCreate.id">
          <div class="form-group">
            <label>Empresa</label>
            <select class="form-control" name="bankId" v-model='formCreate.companyId'>
              <option>Seleccione una empresa</option>
              <option v-for="(company, index) in companies" :key="index" :value="company.id">{{company.name}}</option>
            </select>
          </div>

        </template>

        <div class="form-group">
          <label>Rol</label>
          <select class="form-control" name="bankId" v-model='formCreate.rolId'>
            <option>Seleccione un rol</option>
            <option v-for="(rol, index) in rols" :key="index" :value="rol.id">{{rol.name}}</option>
          </select>
        </div>
        

        

        
      </form>

    </b-modal>



    <b-modal id="modalFilters" ref="modalFilters" title="Filtrar" hide-footer>
      <form v-on:submit.prevent="read">


        <div class="form-group">
          <label>Empresa</label>
          <input type="text" class="form-control" v-model="filters.codeCompany">
        </div>

        

        <div class="form-group">
          <label>Nombre</label>
          <input type="text" class="form-control" v-model="filters.name">
        </div>      

        <div class="form-group">
          <label class='control-label'>Usuario</label>
          <input type="text" class="form-control" v-model="filters.username"> 
        </div>

        <div class="d-inline mr-4">
          <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
          </button>
        </div>
        <div class="d-inline">
          <button type="submit" class="btn btn-primary">Filtrar</button>
        </div>
      </form>

      

    </b-modal>

  </div>
</template>


<script>
import { mapGetters } from "vuex";
import {
  FETCH_USERS,
  FETCH_ROLS,
  CREATE_USER,
  FETCH_COMPANIES,
  UPDATE_USER
} from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      curUser: {},
      curBank: {},
      formCreate: {
        name: "",
        rolId: "",
        username: "",
        password: ""
      },

      filters: {
        name: "",
        username: "",
        codeCompany: ""
      },
      data: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "id", label: "Id", sorteable: true },
        { key: "name", label: "Nombre", sorteable: true },
        { key: "username", label: "Usuario", sorteable: true },
        { key: "Company.name", label: "Empresa", sorteable: true },
        { key: "Rol.name", label: "Rol", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ],
      change: {
        password: "",
        verifyPassword: ""
      }
    };
  },

  validations: {},

  mounted() {
    this.read();
  },
  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_USERS, this.filters);
      this.$store.dispatch(FETCH_ROLS);
      this.$store.dispatch(FETCH_COMPANIES);
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },

    openCreate() {
      this.formCreate = {};
    },

    create() {
      this.$store
        .dispatch(CREATE_USER, this.formCreate)
        .then(result => {
          this.create = {};
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    update() {
      this.$store
        .dispatch(UPDATE_USER, this.formCreate)
        .then(result => {
          this.update = {};
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    submitForm() {
      if (this.formCreate.id) {
        return this.update();
      }
      return this.create();
    },

    edit(current) {
      this.formCreate = current;
    },

    currentUser(current) {
      this.curUser = current;
    }

    /*generateCVS() {
      var total = 0;
      var rows = this.buys.map(item => {
        var status = "";
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else {
          status = "Rechazada";
        }

        total += item.amount;

        return [
          item.id,
          status,
          item.createdAt.substr(0, 10),
          item.createdAt.substr(11, 5),
          item.Carrier.name,
          item.description,
          item.bankName,
          "$" + item.amount
        ];
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Operador",
          "Observacion",
          "Banco",
          "Valor"
        ],
        ...rows,
        ["", "", "", "", "", "", "TOTAL:", "$" + total]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Compras.csv";
      hiddenElement.click();
    }*/
  },
  computed: {
    ...mapGetters(["users", "rols", "companies"])
  }
};
</script>


<style lang="scss">
.user {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .table-head {
    background: #dab51b;
    border: none;
    color: white;
  }
}
</style>
